module.exports = __webpack_public_path__ + "static/media/forgotpassword.e8aeede1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/forgotpassword.jpg
// module id = 449
// module chunks = 0